import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/** Ids only on the payload (ADR 0015 §PII): the name and the text are not carried. */
export const BuyerContractTemplateSavedPayloadSchema = z.object({
  buyerContractTemplateId: z.uuid(),
  workspaceId: z.uuid(),
  version: z.number().int().min(1),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type BuyerContractTemplateSavedPayload = z.infer<typeof BuyerContractTemplateSavedPayloadSchema>;

export const BuyerContractTemplateActivatedPayloadSchema = z.object({
  buyerContractTemplateId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type BuyerContractTemplateActivatedPayload = z.infer<typeof BuyerContractTemplateActivatedPayloadSchema>;

export const BuyerContractTemplateDeletedPayloadSchema = BuyerContractTemplateActivatedPayloadSchema;

export type BuyerContractTemplateDeletedPayload = z.infer<typeof BuyerContractTemplateDeletedPayloadSchema>;
